// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/plugin.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ApproveCapabilitiesRequest, ApproveCapabilitiesResponse, CreateReviewRequest, CreateReviewResponse, DeleteReviewRequest, DeleteReviewResponse, DisablePluginRequest, DisablePluginResponse, EnablePluginRequest, EnablePluginResponse, GetDeveloperPluginsRequest, GetDeveloperPluginsResponse, GetFeaturedPluginsRequest, GetFeaturedPluginsResponse, GetInstalledPluginRequest, GetInstalledPluginResponse, GetPendingCapabilitiesRequest, GetPendingCapabilitiesResponse, GetPluginAnalyticsRequest, GetPluginAnalyticsResponse, GetPluginRequest, GetPluginResponse, InstallPluginRequest, InstallPluginResponse, ListInstalledPluginsRequest, ListInstalledPluginsResponse, ListPluginCategoriesRequest, ListPluginCategoriesResponse, ListPluginsRequest, ListPluginsResponse, ListReviewsRequest, ListReviewsResponse, PublishPluginRequest, PublishPluginResponse, RegisterDeveloperRequest, RegisterDeveloperResponse, SearchPluginsRequest, SearchPluginsResponse, UninstallPluginRequest, UninstallPluginResponse, UpdatePluginConfigRequest, UpdatePluginConfigResponse, UpdatePluginMetadataRequest, UpdatePluginMetadataResponse, UpdateReviewRequest, UpdateReviewResponse } from "./plugin_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.PluginService
 */
export const PluginService = {
  typeName: "omnios.v1.PluginService",
  methods: {
    /**
     * Marketplace
     *
     * @generated from rpc omnios.v1.PluginService.ListPlugins
     */
    listPlugins: {
      name: "ListPlugins",
      I: ListPluginsRequest,
      O: ListPluginsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.GetPlugin
     */
    getPlugin: {
      name: "GetPlugin",
      I: GetPluginRequest,
      O: GetPluginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.SearchPlugins
     */
    searchPlugins: {
      name: "SearchPlugins",
      I: SearchPluginsRequest,
      O: SearchPluginsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.ListPluginCategories
     */
    listPluginCategories: {
      name: "ListPluginCategories",
      I: ListPluginCategoriesRequest,
      O: ListPluginCategoriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.GetFeaturedPlugins
     */
    getFeaturedPlugins: {
      name: "GetFeaturedPlugins",
      I: GetFeaturedPluginsRequest,
      O: GetFeaturedPluginsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Installation
     *
     * @generated from rpc omnios.v1.PluginService.InstallPlugin
     */
    installPlugin: {
      name: "InstallPlugin",
      I: InstallPluginRequest,
      O: InstallPluginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.UninstallPlugin
     */
    uninstallPlugin: {
      name: "UninstallPlugin",
      I: UninstallPluginRequest,
      O: UninstallPluginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.ListInstalledPlugins
     */
    listInstalledPlugins: {
      name: "ListInstalledPlugins",
      I: ListInstalledPluginsRequest,
      O: ListInstalledPluginsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.GetInstalledPlugin
     */
    getInstalledPlugin: {
      name: "GetInstalledPlugin",
      I: GetInstalledPluginRequest,
      O: GetInstalledPluginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.UpdatePluginConfig
     */
    updatePluginConfig: {
      name: "UpdatePluginConfig",
      I: UpdatePluginConfigRequest,
      O: UpdatePluginConfigResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.EnablePlugin
     */
    enablePlugin: {
      name: "EnablePlugin",
      I: EnablePluginRequest,
      O: EnablePluginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.DisablePlugin
     */
    disablePlugin: {
      name: "DisablePlugin",
      I: DisablePluginRequest,
      O: DisablePluginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Capability Approval
     *
     * @generated from rpc omnios.v1.PluginService.ApproveCapabilities
     */
    approveCapabilities: {
      name: "ApproveCapabilities",
      I: ApproveCapabilitiesRequest,
      O: ApproveCapabilitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.GetPendingCapabilities
     */
    getPendingCapabilities: {
      name: "GetPendingCapabilities",
      I: GetPendingCapabilitiesRequest,
      O: GetPendingCapabilitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Reviews
     *
     * @generated from rpc omnios.v1.PluginService.ListReviews
     */
    listReviews: {
      name: "ListReviews",
      I: ListReviewsRequest,
      O: ListReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.CreateReview
     */
    createReview: {
      name: "CreateReview",
      I: CreateReviewRequest,
      O: CreateReviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.UpdateReview
     */
    updateReview: {
      name: "UpdateReview",
      I: UpdateReviewRequest,
      O: UpdateReviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.DeleteReview
     */
    deleteReview: {
      name: "DeleteReview",
      I: DeleteReviewRequest,
      O: DeleteReviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Developer Portal
     *
     * @generated from rpc omnios.v1.PluginService.RegisterDeveloper
     */
    registerDeveloper: {
      name: "RegisterDeveloper",
      I: RegisterDeveloperRequest,
      O: RegisterDeveloperResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.PublishPlugin
     */
    publishPlugin: {
      name: "PublishPlugin",
      I: PublishPluginRequest,
      O: PublishPluginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.UpdatePluginMetadata
     */
    updatePluginMetadata: {
      name: "UpdatePluginMetadata",
      I: UpdatePluginMetadataRequest,
      O: UpdatePluginMetadataResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.GetDeveloperPlugins
     */
    getDeveloperPlugins: {
      name: "GetDeveloperPlugins",
      I: GetDeveloperPluginsRequest,
      O: GetDeveloperPluginsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PluginService.GetPluginAnalytics
     */
    getPluginAnalytics: {
      name: "GetPluginAnalytics",
      I: GetPluginAnalyticsRequest,
      O: GetPluginAnalyticsResponse,
      kind: MethodKind.Unary,
    },
  }
};

